/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.GET_STAFF_ALERTS_REQUEST]: state => {
    state.getStaffAlertRequest = true;
    state.getStaffAlertSuccess = false;
    state.getStaffAlertFailed = false;
    state.getStaffAlertErrors = null;
  },

  [types.GET_STAFF_ALERTS_SUCCESS]: (state, response) => {
    state.getStaffAlertRequest = false;
    state.getStaffAlertSuccess = true;
    state.getStaffAlertFailed = false;
    state.getStaffAlertErrors = null;
    state.staffAlerts = response.data.results;
  },

  [types.GET_STAFF_ALERTS_FAILURE]: (state, error) => {
    state.getStaffAlertRequest = false;
    state.getStaffAlertSuccess = false;
    state.getStaffAlertFailed = true;
    state.getStaffAlertErrors = error.error;
  },

  [types.UPDATE_STAFF_ALERT_REQUEST]: state => {
    state.updateStaffAlertRequest = true;
    state.updateStaffAlertSuccess = false;
    state.updateStaffAlertFailed = false;
    state.updateStaffAlertErrors = null;
  },

  [types.UPDATE_STAFF_ALERT_SUCCESS]: state => {
    state.updateStaffAlertRequest = false;
    state.updateStaffAlertSuccess = true;
    state.updateStaffAlertFailed = false;
  },

  [types.UPDATE_STAFF_ALERT_FAILURE]: (state, error) => {
    state.updateStaffAlertRequest = false;
    state.updateStaffAlertSuccess = false;
    state.updateStaffAlertFailed = true;
    state.updateStaffAlertErrors = error.error;
  },

  [types.GET_NEXT_STAFF_ALERT]: state => {
    state.nextStaffAlert = state.staffAlerts.shift();
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/alerts/mutations.js